// plain
import StarterKit from "@tiptap/starter-kit";
import { Color } from "@tiptap/extension-color";
import ListItem from "@tiptap/extension-list-item";
import FontSize from "tiptap-extension-font-size";
import TextAlign from "@tiptap/extension-text-align";
import FontFamily from "@tiptap/extension-font-family";
import Placeholder from "@tiptap/extension-placeholder";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextStyle from "@tiptap/extension-text-style";
import translations from "@/components/fichaInfo/FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";

// customized
import {
  CustomBold,
  CustomHardBreak,
  CustomHighlight,
  CustomImageResize,
  CustomLineHeight,
  CustomLink,
  CustomParagraph,
  CustomTable,
  CustomTableCell,
  CustomUnderline,
} from "./extensions";

const extensions = [
  StarterKit.configure({
    paragraph: false,
    bold: false,
    hardBreak: false,
  }),

  // custom that override the starter kit
  CustomParagraph.configure(),
  CustomBold.configure(),
  CustomHardBreak.configure(),

  // custom
  CustomUnderline.configure(),
  CustomHighlight.configure({
    multicolor: true,
  }),
  CustomLink.configure({
    validate: false,
    linkOnPaste: false,
    autolink: false,
    openOnClick: "whenNotEditable",
  }),
  CustomTable.configure(),
  CustomTableCell.configure(),
  CustomLineHeight.configure({
    types: ["paragraph", "heading"],
  }),
  CustomImageResize.configure({
    inline: true,
    allowBase64: true,
  }),

  // from @tiptap
  TextStyle.configure(),
  TableHeader.configure(),
  TableRow.configure(),
  FontFamily.configure(),
  FontSize.configure(),
  Color.configure({
    types: [TextStyle.name, ListItem.name],
  }),
  TextAlign.configure({
    types: ["paragraph", "heading"],
  }),
  Placeholder.configure({
    emptyEditorClass: "is-wysiwygempty",
    placeholder: Trans(translations, "WysiwygPlaceHolder"),
  }),
];

export default extensions;
